function isDesktop() {
	return "electron" in window;
}

function isBrowser() {
	return !isDesktop();
}

function openUrl(url: string) {
	if (isDesktop()) {
		window.electron.openUrl(url);
	} else {
		window.open(url);
	}
}

export { isBrowser, isDesktop, openUrl };
